type Props = {
  message?: string;
};

export default function LoadingState({ message = "Loading…" }: Props) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg py-16 text-center">
      <div className="w-10 h-10 mx-auto mb-3 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
      <div className="text-sm font-semibold text-ink-500">{message}</div>
    </div>
  );
}